import "./polyfills";
import * as $ from "jquery";

//Because Telerik ui tests only run in ie, we cannot include validation in webpack bundle We need to include scripts the old way using a script tag. See _layout.cshtml.
//import "jquery-validation";
//import "jquery-validation-unobtrusive";

import "../../node_modules/bootstrap/dist/js/bootstrap.js";

import "./behaviors";


window['$'] = window['jQuery'] = $;
